import { isSupportedAppServiceEnvironment } from "./isSupportedAppServiceEnvironment";
import type { MailboxInfo } from "owa-client-types";

export function isMOS3AppServiceAvailable(mailboxInfo?: MailboxInfo): boolean {
    return isSupportedAppServiceEnvironment(mailboxInfo);
}
